import { Injectable } from '@angular/core';
import { BottomSheetComponent } from '@app/components/bottom-sheet/bottom-sheet.component';
import { BottomSheetOptions } from '@app/components/bottom-sheet/bottom-sheet.model';
import { DateTimeSheetComponent } from '@app/components/datetime-sheet/datetime-sheet.component';
import { ProductSheetComponent } from '@app/components/product-sheet/product-sheet.component';
import { ProductSheetOptions } from '@app/components/product-sheet/product-sheet.model';
import { UpsertSheetComponent } from '@app/components/upsert-sheet/upsert-sheet.component';
import { UpsertSheetOptions } from '@app/components/upsert-sheet/upsert-sheet.model';
import {
  AlertController,
  AlertOptions,
  LoadingController,
  ModalController,
  ToastController,
  ToastOptions,
} from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class BoxxUtilsService {
  private topLoader: HTMLIonLoadingElement;

  constructor(
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {}

  async handleLoading(showLoading: boolean) {
    this.topLoader = await this.loadingCtrl.getTop();
    if (showLoading) {
      if (!this.topLoader) {
        this.topLoader = await this.loadingCtrl.create();
        await this.topLoader.present();
      }
    } else {
      if (this.topLoader) {
        await this.topLoader.dismiss();
        return (this.topLoader = undefined);
      }

      setTimeout(async () => {
        this.topLoader = await this.loadingCtrl.getTop();
        if (this.topLoader) {
          await this.topLoader.dismiss();
          this.topLoader = undefined;
        }
      }, 800);
    }
  }

  async showToastError(options: RequiredToastOptions) {
    return this.showToast({
      duration: 8000,
      ...options,
      //The nex options must not be overwrited!!!
      color: 'danger',
      message: options.message
        ? typeof options.message === 'string'
          ? options.message
          : JSON.stringify(options.message)
        : 'An unknown error ocurred!',
      buttons: [
        {
          icon: 'close',
          side: 'end',
        },
      ],
    });
  }
  async showToastWarn(options: RequiredToastOptions) {
    return this.showToast({
      duration: 5000,
      ...options,
      //The nex options must not be overwrited!!!
      color: 'warning',
      message: options.message,
      buttons: [
        {
          icon: 'close',
          side: 'end',
        },
      ],
    });
  }

  async showToastSuccess(options: RequiredToastOptions) {
    return this.showToast({
      duration: 5000,
      ...options,
      //The nex options must not be overwrited!!!
      color: 'success',
      message: options.message,
      buttons: [
        {
          role: 'cancel',
          text: "ok",
          side: 'end',
        },
      ],
    });
  }

  async showToast(options: RequiredToastOptions) {
    const toast = await this.toastCtrl.create({
      ...options,
    });
    toast.present();
    return toast;
  }

  getToastCtrl() {
    return this.toastCtrl;
  }

  async showAlert(options: AlertOptions) {
    const alert = await this.alertCtrl.create({ ...options });

    alert.present();
  }

  getAlertCtrl() {
    return this.alertCtrl;
  }

  async openBottomSheet(config: BottomSheetOptions): Promise<{ value: string } | undefined> {
    return new Promise((resolve, reject) => {
      try {
        if (!config.breakpoints.includes(1)) {
          config.breakpoints.push(1);
        }
        // If forgets 0 breakpoint, appends to the beginning
        if (!config.breakpoints.includes(0)) {
          config.breakpoints.unshift(0);
        }
        //If initialbreakpoint is not in breakpoint array, append initialBreakpoint to array
        if (!config.breakpoints.includes(config.initialBreakpoint)) {
          config.breakpoints.push(config.initialBreakpoint);
        }
        this.modalCtrl.create({
          component: BottomSheetComponent,
          componentProps: { config: { ...config } },
          cssClass: [`bottom-sheet-modal`, 'modal-QR',`bottom-sheet-modal-${config.maxHeigth || 85}`],
          mode: 'ios',
          initialBreakpoint: config.initialBreakpoint,
          breakpoints: [...config.breakpoints],
          canDismiss: config.canClose,
          backdropDismiss: config.canClose,
        }).then(bottomSheet => {
          bottomSheet.present();
          bottomSheet.onDidDismiss().then(({ data }) => {
            resolve(data);
          });
        });
      }
      catch (err) {
        reject(err)
      }
    });
  }

  async openUpsertSheet(config: UpsertSheetOptions): Promise<{ value: string } | undefined> {
    return new Promise((resolve, reject) => {
      try {
        if (!config.breakpoints.includes(1)) {
          config.breakpoints.push(1);
        }
        // If forgets 0 breakpoint, appends to the beginning
        if (!config.breakpoints.includes(0)) {
          config.breakpoints.unshift(0);
        }
        //If initialbreakpoint is not in breakpoint array, append initialBreakpoint to array
        if (!config.breakpoints.includes(config.initialBreakpoint)) {
          config.breakpoints.push(config.initialBreakpoint);
        }
        this.modalCtrl.create({
          component: UpsertSheetComponent,
          componentProps: { config: { ...config } },
          cssClass: [`bottom-sheet-modal`,`bottom-sheet-modal-${config.maxHeigth || 85}`],
          mode: 'ios',
          handle: false,
          initialBreakpoint: config.initialBreakpoint,
          breakpoints: [...config.breakpoints],
          canDismiss: config.canClose,
          backdropDismiss: config.canClose,
        }).then(bottomSheet => {
          bottomSheet.present();
          bottomSheet.onDidDismiss().then(({ data }) => {
            resolve(data);
          });
        });
      }
      catch (err) {
        reject(err)
      }
    });
  }

  async openDataTimeSheet(config: UpsertSheetOptions): Promise<{ value: string } | undefined> {
    return new Promise((resolve, reject) => {
      try {
        if (!config.breakpoints.includes(1)) {
          config.breakpoints.push(1);
        }
        // If forgets 0 breakpoint, appends to the beginning
        if (!config.breakpoints.includes(0)) {
          config.breakpoints.unshift(0);
        }
        //If initialbreakpoint is not in breakpoint array, append initialBreakpoint to array
        if (!config.breakpoints.includes(config.initialBreakpoint)) {
          config.breakpoints.push(config.initialBreakpoint);
        }
        this.modalCtrl.create({
          component: DateTimeSheetComponent,
          componentProps: { config: { ...config } },
          cssClass: [`bottom-sheet-modal`,`bottom-sheet-modal-${config.maxHeigth || 85}`],
          mode: 'ios',
          handle: false,
          initialBreakpoint: config.initialBreakpoint,
          breakpoints: [...config.breakpoints],
          canDismiss: config.canClose,
          backdropDismiss: config.canClose,
        }).then(bottomSheet => {
          bottomSheet.present();
          bottomSheet.onDidDismiss().then(({ data }) => {
            resolve(data);
          });
        });
      }
      catch (err) {
        reject(err)
      }
    });
  }

  async openProductsSheet(config: ProductSheetOptions): Promise<{ value: string } | undefined> {
    return new Promise((resolve, reject) => {
      try {
        if (!config.breakpoints.includes(1)) {
          config.breakpoints.push(1);
        }
        // If forgets 0 breakpoint, appends to the beginning
        if (!config.breakpoints.includes(0)) {
          config.breakpoints.unshift(0);
        }
        //If initialbreakpoint is not in breakpoint array, append initialBreakpoint to array
        if (!config.breakpoints.includes(config.initialBreakpoint)) {
          config.breakpoints.push(config.initialBreakpoint);
        }
        this.modalCtrl.create({
          component: ProductSheetComponent,
          componentProps: { config: { ...config } },
          cssClass: [`bottom-sheet-modal`, 'modal-QR',`bottom-sheet-modal-${config.maxHeigth || 85}`],
          mode: 'ios',
          initialBreakpoint: config.initialBreakpoint,
          breakpoints: [...config.breakpoints],
          canDismiss: config.canClose,
          backdropDismiss: config.canClose,
        }).then(bottomSheet => {
          bottomSheet.present();
          bottomSheet.onDidDismiss().then(({ data }) => {
            resolve(data);
          });
        });
      }
      catch (err) {
        reject(err)
      }
    });
  }
  
}

interface RequiredToastOptions extends ToastOptions {
  message: string;
}
